'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  min-width: 100px\n  display: flex;\n  flex-direction: row;\n  justify-contetn: center;\n  align-items: stretch;\n  padding: 0;\n  border: solid ', ' ', ';\n  border-radius: ', ';\n\n  input[type=\'number\']::-webkit-outer-spin-button,\n  input[type=\'number\']::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\'number\'] {\n    -moz-appearance: textfield;\n  }\n'], ['\n  width: 100%;\n  min-width: 100px\n  display: flex;\n  flex-direction: row;\n  justify-contetn: center;\n  align-items: stretch;\n  padding: 0;\n  border: solid ', ' ', ';\n  border-radius: ', ';\n\n  input[type=\'number\']::-webkit-outer-spin-button,\n  input[type=\'number\']::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\'number\'] {\n    -moz-appearance: textfield;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border: none;\n  border-right: ', ';\n  border-left: ', ';\n  border-radius: ', ';\n  &:focus {\n    box-shadow: ', '\n    outline: 0;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0\n  }\n  \n'], ['\n  background-color: ', ';\n  border: none;\n  border-right: ', ';\n  border-left: ', ';\n  border-radius: ', ';\n  &:focus {\n    box-shadow: ', '\n    outline: 0;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0\n  }\n  \n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  border: none;\n  font-size: ', ';\n  text-align: center;\n  height: ', ';\n  color: ', ';\n  background-color: ', '\n  font-family: ', ';\n  outline: 0;\n  &:focus {\n    box-shadow: ', ';\n    outline: 0;\n  }\n  &::placeholder {\n    color: ', ';\n  }\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0; \n  }\n'], ['\n  width: 100%;\n  border: none;\n  font-size: ', ';\n  text-align: center;\n  height: ', ';\n  color: ', ';\n  background-color: ', '\n  font-family: ', ';\n  outline: 0;\n  &:focus {\n    box-shadow: ', ';\n    outline: 0;\n  }\n  &::placeholder {\n    color: ', ';\n  }\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0; \n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  margin: 0 ', ';\n'], ['\n  width: 100%;\n  margin: 0 ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents2.default.span(_templateObject, (0, _polished.rem)(1), function (_ref) {
  var theme = _ref.theme;
  return theme.separatorColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.largeBorderRadius;
});

var Button = _styledComponents2.default.button(_templateObject2, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.primaryBg;
}, function (_ref4) {
  var left = _ref4.left,
      theme = _ref4.theme;
  return left ? 'solid ' + (0, _polished.rem)(1) + ' ' + theme.separatorColor : 'none';
}, function (_ref5) {
  var left = _ref5.left,
      theme = _ref5.theme;
  return left ? 'none' : 'solid ' + (0, _polished.rem)(1) + ' ' + theme.separatorColor;
}, function (_ref6) {
  var left = _ref6.left,
      theme = _ref6.theme;
  return left ? theme.largeBorderRadius + ' 0 0 ' + theme.largeBorderRadius : '0 ' + theme.largeBorderRadius + ' ' + theme.largeBorderRadius + ' 0';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.focusShadow;
}); // border: solid ${rem(1)} ${({ theme }) => theme.separatorColor};


var Input = _styledComponents2.default.input(_templateObject3, (0, _polished.rem)(14), (0, _polished.rem)(36), function (_ref8) {
  var theme = _ref8.theme;
  return theme.textColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.color.primaryBg;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontFamily;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.focusShadow;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.form.placeholderColor;
});

var InputWrapper = _styledComponents2.default.div(_templateObject4, (0, _polished.rem)(1));

function SignNumberInput(props) {
  return _react2.default.createElement(Wrapper, null, _react2.default.createElement(Button, {
    left: true,
    onClick: function onClick() {
      return props.handleOnDecrease();
    }
  }, '-'), _react2.default.createElement(InputWrapper, null, _react2.default.createElement(Input, {
    type: 'number',
    value: props.value,
    onChange: function onChange(e) {
      return props.handleOnChange(e.target.value);
    }
  })), _react2.default.createElement(Button, {
    onClick: function onClick() {
      return props.handelOnIncrease();
    }
  }, '+'));
}

SignNumberInput.propTypes = {
  handleOnChange: _propTypes2.default.func.isRequired,
  handelOnIncrease: _propTypes2.default.func.isRequired,
  handleOnDecrease: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.number.isRequired
};
exports.default = SignNumberInput;
SignNumberInput.__docgenInfo = [{
  'description': '',
  'displayName': 'SignNumberInput',
  'methods': [],
  'props': {
    'handleOnChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'handelOnIncrease': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'handleOnDecrease': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'value': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': ''
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/SignNumberInput/index.js'] = {
    name: 'SignNumberInput',
    docgenInfo: SignNumberInput.__docgenInfo,
    path: 'src/SignNumberInput/index.js'
  };
}